const availableStaticPageAliases = ['privacy', 'contacts', 'responsible', 'rules', 'refund', 'faqs'];

export { availableStaticPageAliases };
